import { VyFormSection, VyIcon } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import { VySwitchField, VyTextareaField } from '../../../../../../design-system-adapters/forms';
import { ProductIntegrationSelectors } from '../../modify-panel-shared/selectors';
import { FieldGrid } from '../../modify-panel-shared/layout';
import {
  UPLIFT_UNAVAILABLE_DESCRIPTION,
  useIsUpliftAvailable,
} from '../../modify-panel-shared/hooks/use-is-uplift-available';
import { AutomaticUpgradeSwitch, PayInAdvanceOnTierCrossSwitch } from '../selectors';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export type ProductSettingsSectionProps = {
  showAutomaticUpgrade?: boolean;
  showPayInAdvanceOnTierCross?: boolean;
};

export function ProductSettingsSection({
  showAutomaticUpgrade = false,
  showPayInAdvanceOnTierCross = false,
}: ProductSettingsSectionProps) {
  const { itemIndex: productIndex } = useChargeContext();
  const isUpliftAvailable = useIsUpliftAvailable();

  return (
    <VyFormSection icon={<VyIcon icon="SectionPricing" width={20} height={20} />} title="Product Settings">
      <FieldGrid>
        <VySwitchField<PlanInputForm>
          name={`usageProducts.${productIndex}.upliftConfiguration.inflationaryUpliftEnabled`}
          title="Auto Price uplift"
          description={
            isUpliftAvailable ? 'Annual price lift based on inflation rate' : UPLIFT_UNAVAILABLE_DESCRIPTION
          }
          disabled={!isUpliftAvailable}
          data-field-span="full"
          data-vy="usage-charge-drawer-auto-uplift-switch"
        />

        {showAutomaticUpgrade && <AutomaticUpgradeSwitch />}

        {showPayInAdvanceOnTierCross && <PayInAdvanceOnTierCrossSwitch />}

        <VyTextareaField<PlanInputForm>
          name={`usageProducts.${productIndex}.description`}
          label="Description"
          placeholder="Custom note for the invoice"
          helperText="Appears alongside this item on the invoice"
          minRows={3}
          data-vy="usage-charge-drawer-description"
        />

        {/* Integration/ERP configs are not pricing-related — keep them last. */}
        <ProductIntegrationSelectors />
      </FieldGrid>
    </VyFormSection>
  );
}
